import {
  ANCHOR_TYPE,
  AFTER_ONLY_OFFSET_ANCHOR_TYPES,
  OFFSET_DIRECTION,
  OFFSET_UNIT,
} from '../constants'

/** Default offset when an anchor is created or its type changes. */
export const createDefaultAnchorOffset = (type = ANCHOR_TYPE.participantStartDate) => ({
  amount: 0,
  unit: OFFSET_UNIT.days,
  direction: AFTER_ONLY_OFFSET_ANCHOR_TYPES.includes(type) ? OFFSET_DIRECTION.after : OFFSET_DIRECTION.after,
  days: 0,
})

export const ZERO_OFFSET_API = {
  value: 0,
  unit: 'days',
  direction: 'after',
}
